var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 13.6252H8.62502M2.0625 13.9377L5.53079 12.6037C5.75263 12.5184 5.86355 12.4757 5.96732 12.42C6.0595 12.3706 6.14737 12.3135 6.23003 12.2493C6.32308 12.1771 6.40711 12.0931 6.57517 11.925L13.625 4.87519C14.3154 4.18483 14.3154 3.06555 13.625 2.37519C12.9347 1.68483 11.8154 1.68483 11.125 2.37519L4.07518 9.42501C3.90711 9.59308 3.82308 9.67711 3.75087 9.77016C3.68673 9.85282 3.62963 9.94069 3.58015 10.0329C3.52444 10.1366 3.48178 10.2476 3.39646 10.4694L2.0625 13.9377ZM2.0625 13.9377L3.34883 10.5933C3.44087 10.354 3.4869 10.2343 3.56584 10.1795C3.63482 10.1316 3.72019 10.1135 3.80268 10.1292C3.89708 10.1473 3.98774 10.2379 4.16905 10.4192L5.58098 11.8312C5.7623 12.0125 5.85295 12.1031 5.87098 12.1975C5.88673 12.28 5.86862 12.3654 5.82072 12.4344C5.7659 12.5133 5.64624 12.5593 5.40692 12.6514L2.0625 13.9377Z",
    stroke: "#7B42F5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.64abd2575972ae7999e5226f56d3dc23.svg";
export { ForwardRef as ReactComponent };